module.exports = __webpack_public_path__ + "./images/48d942a740c651356bbfba0babc9788b.webp";